import { BasePriceBreakdown } from "@apac/components/cars";
import { useBalanceWithPoints } from "@apac/components/checkout";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Product } from "@b2bportal/purchase-api";
import { useCheckoutStateSelector } from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { BalanceToPayLineItem, PaymentMethod } from "@hsbc/portal";
import { RewardsAndCreditsLineItem } from "@hsbc/rewards";
import { getProductTotalPrice } from "@hsbc/shared";
import { twoFractionOptions } from "@hsbc/utilities";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const CarsPriceBreakdownReviewSection = ({
  className,
}: PlatformComponentProps) => {
  const [block, cn] = useModuleBEM(styles, "PriceBreakdownReviewSection");
  const { t } = useI18nContext();

  const { remainingBalance } = useBalanceWithPoints();
  const { accountSpecific } = useCheckoutStateSelector(getProductTotalPrice);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{t("priceBreakdown")}</div>
      <BasePriceBreakdown fiatFormatOptions={twoFractionOptions} />
      <div className={cn("divider")} />

      <RewardsAndCreditsLineItem
        accountSpecific={accountSpecific}
        fiatFormatOptions={twoFractionOptions}
      />

      {(remainingBalance?.value ?? 0) > 0 && (
        <BalanceToPayLineItem fiatFormatOptions={twoFractionOptions} />
      )}

      <PaymentMethod product={Product.Ground} />
    </div>
  );
};
